import { render, staticRenderFns } from "./ListadoAcreditaciones.vue?vue&type=template&id=7cb763c4&scoped=true&"
import script from "./ListadoAcreditaciones.vue?vue&type=script&lang=js&"
export * from "./ListadoAcreditaciones.vue?vue&type=script&lang=js&"
import style0 from "./ListadoAcreditaciones.vue?vue&type=style&index=0&id=7cb763c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb763c4",
  null
  
)

export default component.exports